<div class="main-wrapper-section">
    <!--<div class="common-header">
        <h3>MemberShip Contact</h3>
    </div>-->
    <div class="card-section">
        <div class="card-panel">
            <div class="edit-form-panel">
                <div class="field-form-panel">
                    <!--<h4>Edit Contact</h4>
                    <hr />-->                    
                    <form [formGroup]="memContactForm">
                        <div class="flex-form contracts-flex-form">
                            <div class="form-group">
                                <label>Status</label>
                                <select class="form-control" formControlName="csStatusID">
                                    <option value="0">-Select One-</option>
                                    <option *ngFor="let status of memCSStatus_List" [value]="status.statusID">{{status.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Captain Type</label>
                                <select class="form-control" formControlName="captainTypeID">
                                    <option value="0">-Select One-</option>
                                    <option *ngFor="let type of memCaptainType_List" [value]="type.statusID">{{type.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Birthdate</label>
                                <!--<input class="form-control" formControlName="birthdate" />-->
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="birthdate" class="form-control" formControlName="birthdate" id="birthdate">
                                    <mat-datepicker-toggle matSuffix [for]="birthdate"></mat-datepicker-toggle>
                                    <mat-datepicker #birthdate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Gender</label>
                                <select class="form-control" formControlName="genderID">
                                    <option value="0">-Select One-</option>
                                    <option *ngFor="let gender of memGender_List" [value]="gender.statusID">{{gender.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>SSN</label>
                                <input type="text" class="form-control" formControlName="socialSecurityNumber" />
                            </div>
                            <div class="form-group">
                                <label>Association To Primary Captain</label>
                                <select class="form-control" formControlName="associationToPrimaryCaptainID">
                                    <option value="0">-Select One-</option>
                                    <option *ngFor="let captain of memAssociationToPrimaryCaptain_List" [value]="captain.statusID">{{captain.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Onboarded By</label>
                                <select class="form-control" formControlName="onboardedByCLPUserID">
                                    <option value="0">-Select One-</option>
                                    <!--<option *ngFor="let type of typeList" [value]="type.value">{{type.text}}</option>-->
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Booking System Membership</label>
                                <select class="form-control" formControlName="bookingSystemMembershipID">
                                    <option value="0">-Select One-</option>
                                    <!--<option *ngFor="let type of typeList" [value]="type.value">{{type.text}}</option>-->
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Booking System User</label>
                                <select class="form-control" formControlName="bookingSystemUserID">
                                    <option value="0">-Select One-</option>
                                    <!--<option *ngFor="let type of typeList" [value]="type.value">{{type.text}}</option>-->
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Emergency Contact Name</label>
                                <input type="text" class="form-control" formControlName="emergencyContactName" />
                            </div>
                            <div class="form-group">
                                <label>Emergency Contact Phone Number</label>
                                <input type="text" class="form-control" formControlName="emergencyContactPhoneNumber" />
                            </div>
                            <div class="form-group">
                                <label>Relationship To Emergency Contact</label>
                                <select class="form-control" formControlName="relationshipToEmergencyContactID">
                                    <option value="0">-Select One-</option>
                                    <option *ngFor="let contact of memRelationshipToEmergencyContact_List" [value]="contact.statusID">{{contact.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Emergency Contact Mailing Street</label>
                                <input type="text" class="form-control" formControlName="emergencyContactMailingStreet" />
                            </div>
                            <div class="form-group">
                                <label>Emergency Mailing Zip</label>
                                <input type="text" class="form-control" formControlName="emergencyContactMailingZip" />
                            </div>
                            <div class="form-group">
                                <label>Emergency Mailing City</label>
                                <input type="text" class="form-control" formControlName="emergencyContactMailingCity" />
                            </div>
                            <div class="form-group">
                                <label>Emergency Mailing Country</label>
                                <select class="form-control" formControlName="emergencyMailingCountryID" (change)="onChangeCountry($event.target.value)">
                                    <option *ngFor="let country of countryDD" [value]="country.id">{{country.name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Emergency Contact Mailing State</label>
                                <select class="form-control" formControlName="emergencyContactMailingStateID">
                                    <option *ngFor="let state of stateList" [value]="state.id">{{state.text}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Last Booking Portal Activity</label>
                                <!--<input type="datetime" class="form-control" formControlName="lastBookingPortalActivity" />-->  <!--datetime-->
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="lastBookingPortalActivity" class="form-control" formControlName="lastBookingPortalActivity" id="lastBookingPortalActivity">
                                    <mat-datepicker-toggle matSuffix [for]="lastBookingPortalActivity"></mat-datepicker-toggle>
                                    <mat-datepicker #lastBookingPortalActivity></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>CSAT Average Score</label>
                                <input type="text" class="form-control" formControlName="csatAverageScore" />
                            </div>
                            <div class="form-group">
                                <label>Date Of Last Reservation</label>
                                <!--<input type="datetime" class="form-control" formControlName="dateOfLastReservation" />-->  <!--datetime-->
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="dateOfLastReservation" class="form-control" formControlName="dateOfLastReservation" id="dateOfLastReservation">
                                    <mat-datepicker-toggle matSuffix [for]="dateOfLastReservation"></mat-datepicker-toggle>
                                    <mat-datepicker #dateOfLastReservation></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Google Analytics Campaign</label>
                                <input type="text" class="form-control" formControlName="googleAnalyticsCampaign" />
                            </div>
                            <div class="form-group">
                                <label>Google Analytics Content</label>
                                <input type="text" class="form-control" formControlName="googleAnalyticsContent" />
                            </div>
                            <div class="form-group">
                                <label>Google Analytics Medium</label>
                                <input type="text" class="form-control" formControlName="googleAnalyticsMedium" />
                            </div>
                            <div class="form-group">
                                <label>Google Analytics Source</label>
                                <input type="text" class="form-control" formControlName="googleAnalyticsSource" />
                            </div>
                            <div class="form-group">
                                <label>Google Analytics Term</label>
                                <input type="text" class="form-control" formControlName="googleAnalyticsTerm" />
                            </div>
                            <div class="form-group">
                                <label>Boating Experience</label>
                                <select class="form-control" formControlName="boatingExperienceID">
                                    <option value="0">-Select One-</option>
                                    <option *ngFor="let item of memBoatingExperience_List" [value]="item.statusID">{{item.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Driver's License Number</label>
                                <input type="text" class="form-control" formControlName="driversLicenseNumber" />
                            </div>
                            <div class="form-group">
                                <label>Photo URL</label>
                                <input type="text" class="form-control" formControlName="photoURL" />
                            </div>
                            <div class="form-group">
                                <label>Suspended Captain</label>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="suspendedCaptain" formControlName="suspendedCaptain">
                                    <label class="custom-control-label custom-control-label-disabled" for="suspendedCaptain"></label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <div class="button-group">
                                    <button type="button" class="primary-btn" (click)="memContact_Save()">Update</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

